export default "/images/system-user-image.84cbfb.png";